var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-img',{attrs:{"src":"https://alaqeelah.sy/assets/images/logo nav.png","max-width":"100%","contain":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }